import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TituloSubtituloCorFundoContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getTituloSubtituloCorFundo(id: string): Observable<any> {
    return this.getTituloSubtituloCorFundoContents(id).pipe(
      map(res => this.buildResponseTituloSubtituloCorFundoObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryTituloSubtituloCorFundoContents[0].flatData;
  }

  private getTituloSubtituloCorFundoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryTituloSubtituloCorFundoContents(filter: "id eq '${id}'") {
          flatData {
            nome
            titulo
            subtitulo
            corFundo
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseTituloSubtituloCorFundoObject(data: any) {
    return {
      title: data.titulo,
      subtitle: data.subtitulo,
      bgColor: data.corFundo ? data.corFundo : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

}
